import PhysicalVerificationMonitor from 'ui-component/cards/PhysicalVerification/PhysicalVerificationMonitor';

const DistPVMonitorPage = () => {
    return <PhysicalVerificationMonitor />;
};

export default DistPVMonitorPage;
